import { gql } from '@apollo/client';
import { useGraphql } from 'utils/hooks/useGraphql';
import { ModifierAndCreatorById, User } from '../../../domain';

export const fetchListReferenceCreatorsAndModifiers = gql`
  fragment userInfo on User {
    id
    fullName
    avatarUrl
  }
  query getListReferenceCreatorsAndModifiers {
    campaignCreators {
      ...userInfo
    }
    campaignModifiers {
      ...userInfo
    }
    workflowCreators {
      ...userInfo
    }
    workflowModifiers {
      ...userInfo
    }
  }
`;

type CreatorAndModifierResponse = {
  campaignModifiers: User[];
  campaignCreators: User[];
  workflowCreators: User[];
  workflowModifiers: User[];
};

export const useModifiersAndCreatorsQuery = () => {
  const {
    data: {
      campaignCreators = [],
      campaignModifiers = [],
      workflowCreators = [],
      workflowModifiers = [],
    } = {},
  } = useGraphql<CreatorAndModifierResponse>(fetchListReferenceCreatorsAndModifiers);

  const modifiersAndCreators = [
    ...campaignModifiers,
    ...campaignCreators,
    ...workflowCreators,
    ...workflowModifiers,
  ];

  const modifiersAndCreatorsById = modifiersAndCreators.reduce(
    (acc, curr) => ({
      ...acc,
      [curr.id]: curr,
    }),
    {} as ModifierAndCreatorById,
  );

  return {
    modifiersAndCreatorsById,
  };
};
